import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { createGradientOrSolid } from 'utils';

export const StyledBundlePriceButton = styled.div.attrs({
  className: 'bundlePriceButton',
})`
  width: 100%;
  border-radius: 16px;
` as any;

export const StyledBundlePrice = styled.div`
  font-family: var(--font-family);
  background: ${({ bundleButtonColor }: any) =>
    bundleButtonColor && createGradientOrSolid(bundleButtonColor)};
  height: 36px;
  border-radius: 20px;
  border: 2px solid #ffd74b;
  box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.25) inset,
    0px 2px 2px 0px rgba(57, 27, 5, 0.8),
    0px 6px 2px 0px rgba(255, 255, 255, 0.4) inset;
  display: flex;
  direction: ${(props: any) => props.direction};
  justify-content: center;
  align-items: center;
  color: ${({ bundleButtonTextColor }: any) => bundleButtonTextColor};
  position: relative;
  padding: 0 41px;
  align-self: center;
  margin: 0 auto;

  .totalPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    white-space: nowrap;
    font-weight: 700;
    line-height: 1;

    @media (width < ${breakpoints.mobileS}) {
      font-size: 12px;
    }
  }
` as any;
